import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { tabQuery, type TabFilters } from "@/api/queries";
import type { TabId, TabResponseMap } from "@/api/types";

/** Strongly-typed hook per tab: `useTab("global", filters).data` is
 * inferred as TabGlobalResponse.
 *
 * TanStack Query v5's `queryOptions` widens the queryKey tuple back to
 * `readonly unknown[]` when it flows through `useQuery`, which erases our
 * per-tab generic. We widen the options cast before handing them in and
 * re-narrow the return type on the way out — the runtime shape is the
 * same, the cast just gives consumers a correctly-typed `data`. */
export function useTab<K extends TabId>(
  tabId: K,
  filters: TabFilters,
): UseQueryResult<TabResponseMap[K], Error> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return useQuery(tabQuery(tabId, filters) as any) as UseQueryResult<
    TabResponseMap[K],
    Error
  >;
}
